import { Button } from "react-bootstrap";

import { DateTime } from "luxon";

import { getDateFromIso } from "../../../_helpers/stringHelper";
import Next from "../../../assets/svg/Next";
import KeyDataGridComponent from "../../../common/components/KeyDataGridComponent";
import ServiceTypeComponent from "../../../common/components/ServiceTypeComponent.tsx";
import history from "../../../routes/history";
import { IService } from "../../serviceOrdering/reducers";

type ShortAgendaRowProps = {
  service: IService;
};

const ShortAgendaRow = ({ service }: ShortAgendaRowProps) => {
  // const [showModal, setShowModal] = useState(false);

  return (
    <div
      className="rounded-3 p-2 px-lg-4 mt-1 cursor-pointer short-agenda"
      style={{ backgroundColor: "rgba(72, 131, 247, 0.08)" }}
      onClick={() => history.push(`/order/view/${service.id}`)}
    >
      <div className="short-agenda-id" style={{ flex: 1 }}>
        {service.datedReference}
      </div>
      <div
        className="d-flex align-items-center justify-content-center"
        style={{ flex: 2 }}
      >
        <ServiceTypeComponent type={service.type as keyof object} />
      </div>
      <div
        className="d-flex align-items-center justify-content-between gap-2"
        style={{ flex: 1 }}
      >
        <div className="short-agenda-id">
          {getDateFromIso(service.appointment?.startDate)}
        </div>
        <div className="short-agenda-id">
          {getDateFromIso(
            service.appointment?.startDate,
            DateTime.TIME_24_SIMPLE,
          )}
        </div>
        <KeyDataGridComponent service={service} />
        <Button
          variant="none"
          onClick={() => history.push(`/order/view/${service.id}`)}
        >
          <Next color="#000D5B" />
        </Button>
      </div>
      {/*<ModalOrderInfo show={showModal} setShow={setShowModal} agenda={props} />*/}
    </div>
  );
};

export default ShortAgendaRow;
